<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="filteredBudgetList"
      :loading="loading"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr :class="{ newItem: props.item.isNew }">
          <td v-if="canEdit" class="text-xs-center no-wrap">
            <v-tooltip
              :disabled="
                (props.item.isRequestable || props.item.isEditable) &&
                  !insertionOrder.isOverBudgetLimit
              "
              top
            >
              <template v-slot:activator="{ on }">
                <div v-on="on" class="d-inline-block">
                  <v-btn
                    v-if="
                      !props.item.latestRequest.isCancelable &&
                        !props.item.isNew
                    "
                    :disabled="
                      !(
                        (props.item.isRequestable || props.item.isEditable) &&
                        !insertionOrder.isOverBudgetLimit
                      )
                    "
                    @click="openEditModal(props.item)"
                    >変更申請
                  </v-btn>
                </div>
              </template>
              <span
                >期間が終了した予算について、変更申請を行うことはできません。</span
              >
            </v-tooltip>
            <v-btn
              v-if="
                props.item.isResubmittable &&
                  !insertionOrder.isOverBudgetLimit &&
                  !isUpperBudgetLimit
              "
              @click="openEditModal(props.item)"
              >再申請</v-btn
            >
            <v-tooltip :disabled="props.item.isDeleteRequestable" top>
              <template v-slot:activator="{ on }">
                <div v-on="on" class="d-inline-block">
                  <v-btn
                    v-if="
                      !(
                        props.item.isNew ||
                        props.item.latestRequest.isCancelable ||
                        insertionOrder.isNew
                      )
                    "
                    :disabled="!props.item.isDeleteRequestable"
                    @click="openDeleteRequestModal(props.item)"
                    >削除申請
                  </v-btn>
                </div>
              </template>
              <span>開始日以降削除申請を行うことはできません。</span>
            </v-tooltip>
            <v-btn
              v-if="
                props.item.latestRequest.isCancelable || insertionOrder.isNew
              "
              @click="openCancelRequestModal(props.item)"
              >申請取り消し</v-btn
            >
          </td>
          <td class="text-xs-center no-wrap">
            <AppPeriod
              :start="props.item.summary.startTime"
              :end="props.item.summary.endTime"
              is-date
            />
          </td>
          <td class="text-xs-right">
            <AppCurrency
              :value="props.item.summary.budget"
              :currency="currency"
            />
          </td>
          <td class="text-xs-left">
            <RequestDescription
              v-if="props.item.requestStatus != null"
              :status="props.item.requestStatus"
              :type="props.item.requestType"
              :class="{ newItemValue: props.item.isNew }"
              @click="openLatestRequst(props.item)"
            />
          </td>
          <td class="text-xs-center">
            <v-btn @click="openDetailModal(props.item)" small>詳細</v-btn>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <div>登録されている案件予算はありません</div>
      </template>
    </v-data-table>
    <AppModalEdit
      v-if="focusedItem"
      v-model="editModalVisible"
      :is-exec-button-disabled="
        focusedItem.latestRequest.requestStatus === 'waiting'
      "
      :isExecButtonDisabled="
        !isEditBudgetValid && showEditBudgetValidationError
      "
      @clickExec="onSubmit"
      @cancel="close"
      :title="focusedItem.isNew ? '案件予算' : '変更申請'"
      exec-button-text="申請"
      cancel-button-text="キャンセル"
    >
      <EditBudgetForm
        ref="form"
        v-if="
          focusedItem &&
            (focusedItem.isEditable ||
              focusedItem.isRequestable ||
              focusedItem.isResubmittable)
        "
        :isValid="isEditBudgetValid"
        :showValidationError="showEditBudgetValidationError"
        :insertion-order="insertionOrder"
        :advertiser="advertiser"
        :budgetIdOrRequestId="editFormId"
        :startTime="editFormStartTime"
        :endTime="editFormEndTime"
        :budgetAmount="editFormBudgetAmount"
        :isRealBudget="!focusedItem.isNew"
        :budget="focusedItem"
        :budget-list="budgetList"
        :onChangeShowValidationError="onChangeEditBudgetShowValidationError"
        @success="close"
        @onValidate="onValidateEditBudget"
      />
    </AppModalEdit>
    <CancelRequestModal
      v-if="focusedItem"
      v-model="cancelRequestModalVisible"
      :latestRequest="focusedItem.latestRequest"
      @cancelRequest="onCancelRequest"
    />
    <DetailModal
      v-if="focusedItem"
      v-model="detailModalVisible"
      :advertiser="advertiser"
      :budget="focusedItem"
    />
    <DeleteRequestModal
      v-if="focusedItem"
      v-model="deleteRequestModalVisible"
      :advertiser="advertiser"
      :insertion-order="insertionOrder"
      :budget="focusedItem"
      @requestDeleteBudget="onRequestDeleteBudget"
      @success="close"
      @cansel="close"
    />
    <LatestRequestModal
      v-if="focusedItem"
      v-model="latestRequestModalVisible"
      :currency="currency"
      :budget="focusedItem"
    />
  </div>
</template>

<script>
import RequestDescription from '../../../../Shared/Presentation/Request/RequestDescription.vue'
import EditBudgetForm from '../Form/EditBudgetForm'
import DeleteRequestModal from '../Form/DeleteRequestModal'
import DetailModal from './DetailModal'
import LatestRequestModal from './LatestRequestModal'
import CancelRequestModal from './CancelRequestModal'

import { CreateBudgetRequestFormItem } from '@/models/BudgetRequest'

import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'

/* eslint vue/prop-name-casing: 0 */
export default {
  name: 'BudgetTable',
  components: {
    EditBudgetForm,
    CancelRequestModal,
    DetailModal,
    DeleteRequestModal,
    LatestRequestModal,
    RequestDescription,
  },
  props: {
    insertionOrder: {
      type: Object,
      required: true,
    },
    budgetList: {
      type: Array,
      required: true,
    },
    advertiser: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    canEdit: Boolean,
    showNewRequest: Boolean,
    isUpperBudgetLimit: Boolean,
  },
  data() {
    return {
      editModalVisible: false,
      cancelRequestModalVisible: false,
      detailModalVisible: false,
      deleteRequestModalVisible: false,
      latestRequestModalVisible: false,
      focusedItem: null,
      showEditBudgetValidationError: false,
      isEditBudgetValid: true,
    }
  },
  computed: {
    headers() {
      const headers = [
        { text: '変更申請', value: 'edit', align: 'center', sortable: false },
        {
          text: '期間',
          value: 'period',
          align: 'center',
          sortable: false,
        },
        { text: '予算', value: 'budget', sortable: false },
        { text: '備考', sortable: false },
        { text: '詳細', sortable: false },
      ]
      if (!this.canEdit) headers.shift()
      return headers
    },
    currency() {
      return this.advertiser.currency
    },
    filteredBudgetList() {
      return this.budgetList
        .filter(item => !item.isNew || this.showNewRequest)
        .sort(
          (a, b) =>
            new Date(a.summary.startTime) - new Date(b.summary.startTime),
        )
    },
  },
  methods: {
    openEditModal(budget) {
      /**
       * EditBudgetFormにstartTime, endTime, budgetAmountを渡すには、
       * 本来、this.forcusItem = forcusItem だけ行えば良い。
       * (forcusItem ObjectはstartTime, endTime, budgetAmountをもっているので）
       *
       * しかし、forcusItemの中身（BudgetRequest）が複雑すぎるため、
       * EditBudgetFormで使用することは困難である。
       *
       * よってforcusItemとはべつに、budgetの中からstartTime, endTime, budgetAmountを
       * 抽出し、EditBudgetFormに渡すように修正した。
       */
      if (budget.id === undefined) {
        // 再申請の場合
        this.editFormId = budget.latestRequest.id
        this.editFormStartTime = budget.latestRequest.startTime
        this.editFormEndTime = budget.latestRequest.endTime
        this.editFormBudgetAmount = budget.latestRequest.budget
      } else {
        // 変更申請の場合
        this.editFormId = budget.id
        this.editFormStartTime = budget.startTime
        this.editFormEndTime = budget.endTime
        this.editFormBudgetAmount = budget.budget
      }
      this.focusedItem = budget
      this.editModalVisible = true
    },
    openCancelRequestModal(budget) {
      this.focusedItem = budget
      this.cancelRequestModalVisible = true
    },
    openDetailModal(budget) {
      this.focusedItem = budget
      this.detailModalVisible = true
    },
    openDeleteRequestModal(budget) {
      this.focusedItem = budget
      this.deleteRequestModalVisible = true
    },
    openLatestRequst(budget) {
      this.focusedItem = budget
      this.latestRequestModalVisible = true
    },
    async onSubmit() {
      this.$refs.form.submit()
    },
    close() {
      this.focusedItem = null
      this.editModalVisible = false
      this.deleteRequestModalVisible = false
      this.cancelRequestModalVisible = false
    },
    async onCancelRequest(budget) {
      if (this.insertionOrder.isNew) {
        this.$emit('cancelRequest', this.focusedItem)
      } else {
        await budget.cancel()
        this.insertionOrder.fetchBudgetList()
      }
      this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
        type: snackbarType.SUCCESS,
        message: '申請を取り消しました',
      })
      this.close()
    },
    onRequestDeleteBudget() {
      new CreateBudgetRequestFormItem(this.focusedItem).requestDeleteBudget()
      this.insertionOrder.fetchBudgetList()
    },
    // 予算編集用のmethod
    onChangeEditBudgetShowValidationError(showValidationError) {
      this.showEditBudgetValidationError = showValidationError
    },
    onValidateEditBudget(validity) {
      this.isEditBudgetValid = validity
    },
  },
}
</script>

<style scoped lang="scss">
.newItem {
  td {
    color: #999999;

    .newItemValue {
      color: #999999;
    }
  }
}
</style>
